import {
  Building2 as LocationCity,
  Contact as AccountBox,
  User as Person
} from "lucide-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa"; // Import an icon (for example, FontAwesome download icon)
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getInvoices } from "../../../../api/action/order";
import { fetchStudent } from "../../../../api/action/user";
import BackButton from "../components/CustomFields/BackButton";
import InputField from "../components/CustomFields/InputField";
import InstitutionHeader from "../components/InstitutionHeader";
import BackgroundComponent from "../components/theme/BackgroundAnimation";

const ApplicantForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const company = useSelector((state) => state.companyReducer.company);

  const [student, setStudent] = useState({
    primaryId: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    gender: "",
    status: "NEW",
    addressList: [
      { streetName1: "", city: "", state: "", zipcode: "", country: "" },
    ],
    dynamicAttributes: [
      { name: "Nationality", value: "" },
      { name: "Community", value: "" },
    ],
    contactPerson: { firstName: "", lastName: "", email: "", phoneNumber: "" },
    parentDetails: [
      {
        relationshipType: "Father",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        occupation: "",
      },
      {
        relationshipType: "Mother",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        occupation: "",
      },
    ],
  });

  // const auth = useSelector((state) => state?.auth.isAuthenticated);
  const auth = useSelector((state) => state?.auth.data?.isAuthenticated);

  useEffect(() => {
    // const auth = localStorage.getItem("isAuthenticated");
    if (!auth) {
      navigate("/sign-in");
      return;
    }
    const loadStudentData = async () => {
      try {
        // replae with userEmail
        const email = localStorage.getItem("email");
        if (!email) return;

        const response = await dispatch(fetchStudent({ email }));
        if (response.error) {
          return;
        }
        setStudent(response);
        const { primaryId } = response; // Get primaryId from response

        if (primaryId) {
          await dispatch(getInvoices(primaryId)); // Pass only primaryId (userId)
        }
      } catch {
        // Existing page has no inline error state; keep the application view stable on load failure.
      }
    };

    loadStudentData();
  }, [auth, dispatch, navigate]);

  const generatePDF = () => {
    const content = document.getElementById("applicationForm");
    if (!content) return;

    const downloadButton = document.querySelector("#downloadButton");
    if (downloadButton) {
      downloadButton.style.display = "none"; // Hide the button during PDF generation
    }

    html2canvas(content, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = canvas.height;
      let position = 0;
      const addressStartHeight = 200
      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();
      if (heightLeft > addressStartHeight) {
        pdf.addPage();
        position = addressStartHeight - pdfHeight;
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
      }
      pdf.save("Application_Form.pdf");

      if (downloadButton) {
        downloadButton.style.display = "";
      }
    });
  };

  const companyLogo = company.logoLocation;

  return (
    <>  <div className="min-h-screen overflow-hidden bg-gradient-to-br from-blue-600 to-indigo-800 relative scroll-smooth">
      {/* Background Animation */}
      <BackgroundComponent />

      <div className="fixed top-4 left-4 z-20" style={{ paddingTop: '80px' }}>
        <BackButton style={{ position: 'fixed', paddingLeft: '0' }} />
      </div>
      <div className="relative z-10 max-w-6xl mx-auto p-6 pt-20">
        <div className="min-h-screen relative">
          <br /> <br />

          {/* Background Video */}


          {/* Content */}
          <div className="relative z-10 max-w-6xl mx-auto p-6">
            {/* Header Section */}
            <InstitutionHeader />

            <div className="bg-white rounded-xl shadow-lg p-6" id="applicationForm">
              {student?.status === "EMAIL_VERIFIED" ? (
                <div className="flex items-center justify-center h-[300px]">
                  <div className="text-center p-6 bg-white rounded-lg shadow-md">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">
                      You don't have any applications.
                    </h1>
                    <p className="text-gray-600">
                      Please complete your application to view.
                    </p>
                  </div>
                </div>

              ) : (
                <>
                  {companyLogo && (
                    <div className="text-center mb-8">
                      <img
                        src={companyLogo}
                        alt="Company Logo"
                        className="w-40 mx-auto mb-4"
                      />
                    </div>
                  )}

                  <div className="flex flex-col items-center mb-6">
                    <h1 className="text-4xl font-bold text-gray-800 text-center mb-4">
                      {student?.company?.name}
                    </h1>
                    <h2 className="text-3xl  text-gray-800 text-center mb-4">
                      Application Form
                    </h2>

                    <h2 className="text-xl text-gray-800 font-semibold text-center mb-6">
                      Application No - <span className="font-bold text-gray-900">{student?.primaryId}</span>
                    </h2>




                    <div className="flex justify-center w-full">
                      <button
                        id="downloadButton"
                        onClick={generatePDF}
                        style={styles.downloadButton}
                        className="flex items-center ml-auto"
                      >
                        <FaDownload className="mr-2" /> Download PDF
                      </button>
                    </div>

                  </div>

                  <Section

                    title={
                      <div className="mb-4">
                        Personal Information
                      </div>
                    }

                    icon={<Person className="mb-4 h-8 w-8" />}


                    content={
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {[
                          { label: "First Name", value: student?.firstName, onChange: (e) => setStudent({ ...student, firstName: e.target.value }) },
                          { label: "Last Name", value: student?.lastName, onChange: (e) => setStudent({ ...student, lastName: e.target.value }) },
                          { label: "Email", value: student?.email, onChange: (e) => setStudent({ ...student, email: e.target.value }) },
                          { label: "Phone Number", value: student?.phoneNumber, onChange: (e) => setStudent({ ...student, phoneNumber: e.target.value }) },
                          { label: "Gender", value: student?.gender, onChange: (e) => setStudent({ ...student, gender: e.target.value }) },
                        ]
                          .concat(
                            student.dynamicAttributes.map((attr) => ({
                              label: attr.name,
                              value: attr.value,
                              onChange: (e) => {
                                const updatedAttributes = student.dynamicAttributes.map(a => a.name === attr.name ? { ...a, value: e.target.value } : a);
                                setStudent({ ...student, dynamicAttributes: updatedAttributes });
                              }
                            }))
                          )
                          .map((field, index) => (
                            <InputField key={index} label={field.label} value={field.value} onChange={field.onChange} />
                          ))}
                      </div>
                    }
                  />

                  {/* Contact Person Section */}
                  <br />
                  <Section
                    title={
                      <div className="mb-4"> {/* Add margin bottom to the title */}
                        Contact Person
                      </div>
                    }
                    icon={<AccountBox className="mb-4 h-8 w-8" />}
                    content={
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {[
                          { label: "First Name", value: student?.contactPerson?.firstName, onChange: (e) => setStudent({ ...student, contactPerson: { ...student.contactPerson, firstName: e.target.value } }) },
                          { label: "Last Name", value: student?.contactPerson?.lastName, onChange: (e) => setStudent({ ...student, contactPerson: { ...student.contactPerson, lastName: e.target.value } }) },
                          { label: "Email", value: student?.contactPerson?.email, onChange: (e) => setStudent({ ...student, contactPerson: { ...student.contactPerson, email: e.target.value } }) },
                          { label: "Phone Number", value: student?.contactPerson?.phoneNumber, onChange: (e) => setStudent({ ...student, contactPerson: { ...student.contactPerson, phoneNumber: e.target.value } }) },
                        ].map((field, index) => (
                          <InputField key={index} label={field.label} value={field.value} onChange={field.onChange} />
                        ))}
                      </div>
                    }
                  />

                  {/* Address Information Section */}
                  <br />          <br /> <br />          <br /> <br />          <br />

                  <Section
                    title={
                      <div className="mb-4"> {/* Add margin bottom to the title */}
                        Address Information
                      </div>
                    } icon={<LocationCity className="mb-4 h-8 w-8" />}
                    content={
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {student.addressList.map((address, index) => (
                          <>
                            {[
                              {
                                label: "Street line 1", value: address?.streetName1, onChange: (e) => {
                                  const updatedAddresses = student?.addressList.map((a, i) => i === index ? { ...a, streetName1: e.target.value } : a);
                                  setStudent({ ...student, addressList: updatedAddresses });
                                }
                              },
                              {
                                label: "Street line 2", value: address?.streetName2, onChange: (e) => {
                                  const updatedAddresses = student?.addressList.map((a, i) => i === index ? { ...a, streetName2: e.target.value } : a);
                                  setStudent({ ...student, addressList: updatedAddresses });
                                }
                              },
                              {
                                label: "City", value: address?.city, onChange: (e) => {
                                  const updatedAddresses = student?.addressList.map((a, i) => i === index ? { ...a, city: e.target.value } : a);
                                  setStudent({ ...student, addressList: updatedAddresses });
                                }
                              },
                              {
                                label: "State", value: address?.state, onChange: (e) => {
                                  const updatedAddresses = student?.addressList.map((a, i) => i === index ? { ...a, state: e.target.value } : a);
                                  setStudent({ ...student, addressList: updatedAddresses });
                                }
                              },
                              {
                                label: "Zip Code", value: address?.zipcode, onChange: (e) => {
                                  const updatedAddresses = student?.addressList.map((a, i) => i === index ? { ...a, zipcode: e.target.value } : a);
                                  setStudent({ ...student, addressList: updatedAddresses });
                                }
                              },
                              {
                                label: "Country", value: address?.country, onChange: (e) => {
                                  const updatedAddresses = student?.addressList.map((a, i) => i === index ? { ...a, country: e.target.value } : a);
                                  setStudent({ ...student, addressList: updatedAddresses });
                                }
                              },
                            ].map((field, subIndex) => (
                              <InputField key={subIndex} label={field.label} value={field.value} onChange={field.onChange} />
                            ))}
                          </>
                        ))}
                      </div>
                    }
                  />

                  <br />

                  {/* Parent Information Section */}
                  <Section
                    title="Parent Information"
                    icon={<AccountBox className="h-8 w-8" />}
                    content={
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {student.parentDetails?.map((parent, index) => {
                          const relationship = parent?.dynamicAttributes?.find(
                            (attr) => attr.name === "Relationship"
                          )?.value || parent?.relationshipType;

                          return (
                            <React.Fragment key={index}>
                              <InputField label={`${relationship} First Name`} value={parent?.firstName} onChange={(e) => {
                                const updatedParents = student.parentDetails.map((p, i) => i === index ? { ...p, firstName: e.target.value } : p);
                                setStudent({ ...student, parentDetails: updatedParents });
                              }} />
                              <InputField label={`${relationship} Last Name`} value={parent?.lastName} onChange={(e) => {
                                const updatedParents = student.parentDetails.map((p, i) => i === index ? { ...p, lastName: e.target.value } : p);
                                setStudent({ ...student, parentDetails: updatedParents });
                              }} />
                              <InputField label={`${relationship} Email`} value={parent?.email} onChange={(e) => {
                                const updatedParents = student.parentDetails.map((p, i) => i === index ? { ...p, email: e.target.value } : p);
                                setStudent({ ...student, parentDetails: updatedParents });
                              }} />
                              <InputField label={`${relationship} Phone Number`} value={parent?.phoneNumber} onChange={(e) => {
                                const updatedParents = student.parentDetails.map((p, i) => i === index ? { ...p, phoneNumber: e.target.value } : p);
                                setStudent({ ...student, parentDetails: updatedParents });
                              }} />
                              <InputField label={`${relationship} Occupation`} value={parent?.occupation} onChange={(e) => {
                                const updatedParents = student.parentDetails.map((p, i) => i === index ? { ...p, occupation: e.target.value } : p);
                                setStudent({ ...student, parentDetails: updatedParents });
                              }} />
                            </React.Fragment>
                          );
                        })}
                      </div>
                    }
                  />          <br />

                  <Section
                    title="Declaration"
                    content={
                      <div className="mt-4">
                        <p>
                          I hereby declare that the information provided above is true
                          to the best of my knowledge and belief.
                        </p>
                      </div>
                    }
                  />
                </>
              )}
            </div>
          </div>


        </div>
      </div >

    </div >

    </>


  );
};

// Section component for reusable code
const Section = ({ title, icon, content }) => (
  <div className="mt-10">
    <h3 className="text-2xl font-semibold mb-4 flex items-center">
      {icon}
      <span className="ml-2">{title}</span>
    </h3>
    {content}
  </div>
);

const styles = {
  downloadButton: {
    backgroundColor: "#b5a262",
    color: "#fff",
    borderRadius: "5px",
    padding: "8px 16px",
    cursor: "pointer",
  },
};

export default ApplicantForm;
